import { render, staticRenderFns } from "./WizardHomeLayout.vue?vue&type=template&id=4f183d7d"
import script from "./WizardHomeLayout.vue?vue&type=script&lang=ts"
export * from "./WizardHomeLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports